import { Component, OnInit, Input, DoCheck, ElementRef, Output, EventEmitter, ViewChild } from '@angular/core';
import { CfetBaseComponent, CFETILMEndpointsConstant, CfetService, ErrorService, UrlUtil } from '../../../cfet-core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import moment from 'moment';
import { environment } from './../../../../environments/environment';

@Component({
    selector: 'app-customer-information-form',
    templateUrl: './customer-information-form.component.html',
    styleUrls: ['./customer-information-form.component.scss'],
    standalone: false
})
export class CustomerInformationFormComponent extends CfetBaseComponent implements OnInit, DoCheck {

  personalInformationFormGroup: UntypedFormGroup;
  firstName: UntypedFormControl;
  middleName: UntypedFormControl;
  lastName: UntypedFormControl;
  address1Val: UntypedFormControl;
  address2Val: UntypedFormControl;
  cityVal: UntypedFormControl;
  stateValue: UntypedFormControl;
  zipCode: UntypedFormControl;
  mobilenumberControl: UntypedFormControl;
  dateOfBirthFcontrol: UntypedFormControl;
  emailAddress: UntypedFormControl;
  workEmailAddress: UntypedFormControl;
  workidnumber: UntypedFormControl;
  stateValOption: any;
  stateListArr: any[] = [];
  checkStateVal: any;
  currentyear: any;
  currentday: any;
  currentmonth: any;
  disabledSubmitButton = true;
  showPersonalEmailDesc = false;
  showWorkEmail = false;
  showPersonalInfoSection = true;
  showInstantVerificationSection = false;
  showDocUploadSection = false;
  showVerificationNotRequired = false;
  showWorkIdNumberinput = false;
  yesButton: boolean;
  noButton: boolean;
  empButton: boolean;
  volButton: boolean;
  workDept: any;
  selectedEmpVolButton: any;
  selectedEmpIdButton: any;
  phoneNumberErr: boolean;
  dropdowndefaultValue = true;
  isValidDob = true;
  emailAddressEmpty: boolean;
  emailAddressError: boolean;
  workEmailAddressError: boolean;
  workIdError: boolean;
  isValidFirstName = true;
  isValidLastName = true;
  personalAddErrorFlag: boolean;
  selectedconfirmValue: any;
  cityErrorFlag: boolean;
  zipcodeError: boolean;
  hasWorkId: boolean;
  selectedfedEmployee: any;
  isFedEmployee: boolean;
  customerAge: any;
  dobAbove16: boolean;
  email: '';
  entity: any;
  status: any;
  type: any;
  geteligibilityInfo: any;
  respondertypes: any;
  responderTypes: any;
  profileData: any;
  jobfunction: any;
  residentialAdd: any;
  showVerificationPending = false;
  fname: any;
  lname: any;
  programId: any;
  showDocReviewPending = false;
  emailAlreadyExistsFlag = false;
  showLoading = false;
  orgIdSelected: any;
  errorMessage: any;
  spaTerritories: Array<any> = [];
  stateDatas: Array<any> = [];
  @ViewChild('inputEmail') inputEmail: ElementRef;
  @Input() selectedWorkPlace: string;
  @Output() hideEditButton = new EventEmitter<any>();
  @Output() goToInstantVerification = new EventEmitter<any>();
  @Output() setSessionTimeout = new EventEmitter<any>();
  retailAgentGroup: string;
  organizationInfo: {};
  affiliationCode: string;
  codeOrgDetails: string;
  organizationid: any;
  organisationName: any;
  retailFanAccountList: any;
  fanName: any;
  selectedValue = {
    fan: ''
  };
  isSpaOrg: any;
  // RapidSOS orgs can have an empty affiliationCode (no retCode), so this flag identifies them independently.
  isRapidSosOrg = false;
  selectedagencyInfo: any;
  createUserSuccess: boolean;
  tempVerificationStatus: string;
  attributeMap: any;
  sheeridCurrentStep: any;
  userid: any;
  @Output() showCancelModal = new EventEmitter<any>();
  userType: any;
  subType: any;

  constructor(private formBuilder: UntypedFormBuilder,
    private elementRef: ElementRef,
    private urlUtil: UrlUtil,
    private cfetService: CfetService,
    private errorService: ErrorService) {
    super();
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.firstName = new UntypedFormControl('', [Validators.required]);
    this.middleName = new UntypedFormControl('', [Validators.required]);
    this.lastName = new UntypedFormControl('', [Validators.required]);
    this.dateOfBirthFcontrol = new UntypedFormControl('', [Validators.required]);
    this.emailAddress = new UntypedFormControl('', [Validators.required]);
    this.workEmailAddress = new UntypedFormControl('');
    this.workidnumber = new UntypedFormControl('');
    this.stateValue = new UntypedFormControl('', [Validators.required]);
    this.mobilenumberControl = new UntypedFormControl('', [Validators.required]);
    this.address1Val = new UntypedFormControl('', [Validators.required]);
    this.address2Val = new UntypedFormControl('', [Validators.required]);
    this.cityVal = new UntypedFormControl('');
    this.zipCode = new UntypedFormControl('', { validators: [Validators.required, Validators.minLength(5)], updateOn: 'change' });

    this.stateValOption = { 'value': 'Select', 'text': 'Select' };
    this.stateListArr = [];
    this.personalInformationFormGroup = new UntypedFormGroup({
      firstName: this.firstName,
      middleName: this.middleName,
      lastName: this.lastName,
      dateOfBirthFcontrol: this.dateOfBirthFcontrol,
      address1Val: this.address1Val,
      address2Val: this.address2Val,
      cityVal: this.cityVal,
      mobilenumberControl: this.mobilenumberControl,
      emailAddress: this.emailAddress,
      workEmailAddress: this.workEmailAddress,
      workidnumber: this.workidnumber,
      stateValue: this.stateValue,
      zipCode: this.zipCode
    });
    const commonListValues = JSON.parse(sessionStorage.getItem('ngStorage-commonListValues'));
    this.stateDatas = commonListValues['validStates'];
    this.spaTerritories = commonListValues['validSPATerritories'];
    Object.keys(this.spaTerritories).forEach((key) => {
      let val = this.spaTerritories[key];
      this.stateDatas = this.stateDatas.concat(val);
    });
    //sorting the stateDatas
    this.stateDatas.sort();
    //setting the state value
    if (this.stateDatas && this.stateDatas.length > 0) {
      this.stateListArr = this.stateDatas.map(
        stateValue => {
          const state = stateValue ? stateValue.split(':')[1] : '';
          return { value: state, text: state };
        });
    }
    this.workDept = this.selectedWorkPlace;
    const currentdate = new Date();
    this.currentyear = currentdate.getFullYear();
    this.currentmonth = currentdate.getMonth() + 1;
    this.currentday = currentdate.getDate();
    if (sessionStorage.getItem('orgInfo') && Object.keys(sessionStorage.getItem('orgInfo')).length !== 0) {
      this.codeOrgDetails = JSON.parse(sessionStorage.getItem('orgInfo'));
      this.isSpaOrg = this.codeOrgDetails['isSpaOrg'];
      this.affiliationCode = this.codeOrgDetails['affiliationCode'];
      this.isRapidSosOrg = !!this.codeOrgDetails['isRapidSOS'];
    }
    if (sessionStorage.getItem('eligibilityInfo') && Object.keys(sessionStorage.getItem('eligibilityInfo')).length !== 0) {
      this.geteligibilityInfo = JSON.parse(sessionStorage.getItem('eligibilityInfo'));
      this.selectedagencyInfo = this.geteligibilityInfo.eligibilityStatus;
      this.entity = this.geteligibilityInfo.entity;
      this.status = this.geteligibilityInfo.status;
      this.type = this.geteligibilityInfo.type;
      this.jobfunction = this.geteligibilityInfo.selectedRoleVal;
      this.userType = this.geteligibilityInfo.userType;
      this.subType = this.geteligibilityInfo.subType;
    }
  }

  ngDoCheck() {
    this.disabledSubmitButton = (!((this.yesButton || this.noButton) && (this.empButton || this.volButton)
      && ((this.hasWorkId || !this.hasWorkId) && !(this.selectedEmpIdButton === null || this.selectedEmpIdButton === undefined)) &&
      ((this.isFedEmployee || !this.isFedEmployee) && !(this.selectedfedEmployee === null || this.selectedfedEmployee === undefined)))
      || this.isValidFirstName === false || this.isValidLastName === false
      || (this.emailAddressError === undefined || this.emailAddressError)
      || (this.emailAddressEmpty === undefined || this.emailAddressEmpty)
      || (this.emailAlreadyExistsFlag === undefined || this.emailAlreadyExistsFlag)
      || (this.phoneNumberErr === undefined || this.phoneNumberErr)
      || (this.isValidDob === false || this.dobAbove16 === true || this.dateOfBirthFcontrol.value === '')
      || (this.personalAddErrorFlag === undefined || this.personalAddErrorFlag)
      || (this.stateValue.value === '' || this.stateValue.value === 'Select')
      || (this.cityErrorFlag === undefined || this.cityErrorFlag)
      || (this.zipcodeError === undefined || this.zipcodeError)
      || this.workEmailAddressError === true || this.workIdError === true);
  }

  onChangeState(event) {
    this.checkStateVal = '';
    this.stateValue.setValue(event.value);
    if (this.stateValue.value !== 'select') {
      this.dropdowndefaultValue = false;
      // if screen width greater than 1024
      if (screen.width > 1024) {
        const inputelem1 = this.elementRef.nativeElement.querySelector('#select_state');
        inputelem1.setAttribute('style', 'color : #333 !important');
      } else {
        const inputelem1 = this.elementRef.nativeElement.querySelector('#select_state').nextElementSibling;
        inputelem1.setAttribute('style', 'color : #333 !important');
      }
    } else {
      // if stateValue is exist
      this.dropdowndefaultValue = true;
      const inputelem1 = this.elementRef.nativeElement.querySelector('#select_state');
      inputelem1.setAttribute('style', 'color : #868585 !important');
    }
  }

  onClickState(event) {
    this.checkStateVal = (event.target.ariaExpanded === 'true') ? 'dropdown-opened' : '';
  }

  checkCity() {
    this.cityErrorFlag = this.cityVal.value.length > 1 ? false : true;
  }

  checkAddress() {
    this.personalAddErrorFlag = this.address1Val.value.length > 1 ? false : true;
  }

  checkLastname() {
    const regexpName = new RegExp(/^([A-Z0-9a-z\s\'\-]{2,})$/);
    this.isValidLastName = regexpName.test(this.lastName.value.trim());
  }

  checkFirstname() {
    const regexpName = new RegExp(/^([A-Z0-9a-z\s\'\-]{2,})$/);
    this.isValidFirstName = regexpName.test(this.firstName.value.trim());
  }

  checkWorkId() {
    this.workIdError = this.workidnumber.value.length > 0 ? false : true;
  }

  checkZip() {
    this.zipCode.value.replace(/[^0-9\-]/g, '');
    this.zipCode.setValue(this.zipCode.value.replace(/[^0-9\-]/g, ''));
    this.zipcodeError = this.zipCode.value.length < 5 ? true : false;
  }

  formatDOB(e) {
    const date = this.dateOfBirthFcontrol.value;
    const datenoslash = this.dateOfBirthFcontrol.value.replace('/', '');
    // set dob value with slice of date 0 to 2
    if (this.dateOfBirthFcontrol.value && this.dateOfBirthFcontrol.value.length >= 2 && !isNaN(datenoslash) && this.dateOfBirthFcontrol.value.indexOf('/') === -1
      && (e.keyCode !== 8 || e.key.toLowerCase() !== 'backspace')) {
      this.dateOfBirthFcontrol.setValue(date.slice(0, 2).concat('/'));
    }
    // set dob value with slice of date 0 to 4
    if (this.dateOfBirthFcontrol.value && this.dateOfBirthFcontrol.value.length === 4 && !isNaN(datenoslash) && this.dateOfBirthFcontrol.value.indexOf('/') === 1
      && this.dateOfBirthFcontrol.value.lastIndexOf('/') !== 3 && (e.keyCode !== 8 || e.key.toLowerCase() !== 'backspace')) {
      this.dateOfBirthFcontrol.setValue(date.slice(0, 4).concat('/') + date.slice(5));
    }
    // set dob value with date only
    if (this.dateOfBirthFcontrol.value && this.dateOfBirthFcontrol.value.length > 4 && !isNaN(datenoslash) && this.dateOfBirthFcontrol.value.indexOf('/') !== 1
      && (e.keyCode !== 8 || e.key.toLowerCase() !== 'backspace')) {
      if (this.dateOfBirthFcontrol.value.lastIndexOf('/') === 3 || this.dateOfBirthFcontrol.value.lastIndexOf('/') === 4) {
        this.dateOfBirthFcontrol.setValue(date);
      } else {
        this.dateOfBirthFcontrol.setValue(date.slice(0, 5).concat('/') + date.slice(6));
      }
    }
  }

  checkPhoneNumber() {
    this.phoneNumberErr =
      (this.mobilenumberControl.value === '' || (this.mobilenumberControl.value && this.mobilenumberControl.value.toString().length > 0 &&
        (this.mobilenumberControl.value.toString().length < 10 || this.mobilenumberControl.value.toString().length === 11))) ? true : false;
  }

  validateEmailAddr(emailType) {
    const emailRegex = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/);
    // if emailType is personal
    if (emailType === 'personal') {
      if (this.emailAddress.value === '' || this.emailAddress.value === undefined) {
        this.emailAddressEmpty = true;
      } else {
        this.emailAddressEmpty = false;
        this.showPersonalEmailDesc = true;
        this.emailAddressError = !emailRegex.test(this.emailAddress.value);
      }
    }
    // if emailType is work
    if (emailType === 'work') {
      this.workEmailAddressError = this.workEmailAddress.value === '' ? false : !emailRegex.test(this.workEmailAddress.value);
    }
  }

  checkDOB() {
    this.customerAge = '';
    this.isValidDob = moment(this.dateOfBirthFcontrol.value, ['MM/DD/YYYY', 'M/D/YYYY'], true).isValid();
    // set customer age
    if (this.isValidDob) {
      this.dateOfBirthFcontrol.setValue(moment(this.dateOfBirthFcontrol.value).format('MM/DD/YYYY'));
      this.customerAge = moment().diff(this.dateOfBirthFcontrol.value, 'years', false);
      this.dobAbove16 = this.customerAge < 16;
    }
  }

  hasWorkEmail(event, type) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      // if type is yes
      if (type === 'yes') {
        this.noButton = false;
        this.yesButton = true;
        this.showWorkEmail = true;
        this.selectedconfirmValue = 'Yes';
      }
      // if type is no
      if (type === 'no') {
        this.noButton = true;
        this.yesButton = false;
        this.showWorkEmail = false;
        this.selectedconfirmValue = 'No';
        this.workEmailAddressError = false;
        this.workEmailAddress.setValue('');
      }
    }
  }

  onChangeEmail() {
    this.emailAlreadyExistsFlag = false;
  }

  hasWorkIDNumber(event, type) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      // if type is yes
      if (type === 'yes') {
        this.selectedEmpIdButton = 'Yes';
        this.hasWorkId = true;
        this.showWorkIdNumberinput = true;
      }
      // if type is yes
      if (type === 'no') {
        this.hasWorkId = false;
        this.selectedEmpIdButton = 'No';
        this.showWorkIdNumberinput = false;
        this.workIdError = false;
        this.workidnumber.setValue('');
      }
    }
  }

  fedemployee(event, type) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      // if type is yes
      if (type === 'Yes') {
        this.selectedfedEmployee = 'Yes';
        this.isFedEmployee = true;
      }
      // if type is yes
      if (type === 'No') {
        this.selectedfedEmployee = 'No';
        this.isFedEmployee = false;
      }
    } else {
      this.selectedfedEmployee = '';
      this.isFedEmployee = false;
    }
  }

  employeeOrVolunteer(event, type) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      // if type is employee
      if (type === 'employee') {
        this.volButton = false;
        this.empButton = true;
        this.selectedEmpVolButton = 'EMPLOYEE';
      }
      // if type is volunteer
      if (type === 'volunteer') {
        this.empButton = false;
        this.volButton = true;
        this.selectedEmpVolButton = 'VOLUNTEER';
      }
    } else {
      this.volButton = false;
      this.empButton = false;
      this.selectedEmpVolButton = '';
    }
  }

  renderNewValues(): any {
    return {
      'action': 'Personal Information',
      'firstname': this.firstName.value.trim(),
      'middlename': this.middleName.value ? this.middleName.value : '',
      'lastname': this.lastName.value.trim(),
      'emailaddress': this.emailAddress.value,
      'dob': this.dateOfBirthFcontrol.value,
      'ctn': this.mobilenumberControl.value,
      'address1': this.address1Val.value,
      'address2': this.address2Val.value ? this.address2Val.value : '',
      'city': this.cityVal.value,
      'zipCode': this.zipCode.value,
      'state': this.stateValue.value,
      'workemail': this.workEmailAddress.value ? this.workEmailAddress.value : '',
      'workid': this.workidnumber.value ? this.workidnumber.value : '',
      'empOrVol': this.selectedEmpVolButton,
      'yesOrNoClicked': this.selectedconfirmValue,
      'workId': this.hasWorkId
    };
  }

  verifyIdentityActivationFail(error, newValues) {
    if (error && error.error.errorcode && error.error.errorcode === 1033) {
      // if affiliation code exists
      if (this.affiliationCode && this.codeOrgDetails && !this.codeOrgDetails['isSpaOrg']) {
        this.tempVerificationStatus = 'NotRequired';
        this.getOrgDataByAffillationCode();
      } else {
        this.sheeridServicecall(newValues);
      }
    } else if (error && error.error.errorcode && (error.error.errorcode === 1019 || error.error.errorcode === 1016 || error.error.errorcode === 1047)) {
      // if errorocde is 1019 or 1047
      this.showLoading = false;
      this.emailAlreadyExistsFlag = true;
      this.inputEmail.nativeElement.focus();
      const messageArray = [];
      messageArray.push(this.cfetMessages.CFET_ERROR_1007, this.cfetMessages.CFET_eligibility_existing_user);
      this.errorService.displayErrorMessageList(messageArray);
    }
  }

  verifyIdentityActivationSuccess(data, newValues) {
    console.log("customer-information-form - verifyIdentityActivationSuccess: start");
    console.log("data = ");
    console.table(data);
    if (data && data.errorcode && data.errorcode === 1033) {
      // if affiliation code exists
      if (this.affiliationCode && this.codeOrgDetails && !this.codeOrgDetails['isSpaOrg']) {
        this.tempVerificationStatus = 'NotRequired';
        this.getOrgDataByAffillationCode();
      } else {
        this.sheeridServicecall(newValues);
      }
    } else if (data && data.error && data.error.errorcode ||
      (data && data.status === 'Success' && data.available_notification_methods !== undefined) || (data && data.errorcode === 1047)) {
      // if data with success status
      this.showLoading = false;
      this.emailAlreadyExistsFlag = true;
      this.inputEmail.nativeElement.focus();
      const messageArray = [];
      messageArray.push(this.cfetMessages.CFET_ERROR_1007, this.cfetMessages.CFET_eligibility_existing_user);
      this.errorService.displayErrorMessageList(messageArray);
    }
  }

  submit(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13 && !this.disabledSubmitButton) {
      const newValues = this.renderNewValues();
      sessionStorage.setItem('ngStorage-savedData', JSON.stringify(newValues));
      this.fname = this.firstName.value.trim();
      this.lname = this.lastName.value.trim();
      const request = {
        'userid': this.emailAddress.value.trim(),
        'company_id': environment.companyId,
        'verification_attributes':
          [
            {
              'attribute_name': 'sn',
              'attribute_value': this.lastName.value.trim()
            }
          ],
        'notification_value': '',
        'notification_method': 'list',
        'notification_flow': 'actv'
      };
      this.errorService.showError.next(false);
      window.scrollTo(0, 0);
      this.showLoading = true;
      this.cfetService.cfetLivePost(request, CFETILMEndpointsConstant.VERIFY_IDENTITY_ACTIVATION).subscribe((data) => {
        console.log("customer-information-form - submit: calling verifyIdentityActivationSuccess");
        this.verifyIdentityActivationSuccess(data, newValues);
      }, (error) => {
        console.log("customer-information-form - submit: calling verifyIdentityActivationFail");
        this.verifyIdentityActivationFail(error, newValues);
      });
    }
  }

  getOrgDataByAffillationCode() {
    this.organizationInfo = {};
    this.showLoading = true;
    this.orgIdSelected = this.codeOrgDetails['orgid'];
    this.createOrgsData(this.codeOrgDetails['orgProfileInfo'], this.codeOrgDetails['orgid']);
  }

  setEntityStatus(entityStatus: any): any {
    let entStatus;
    entityStatus.forEach(val => {
      if (val.status && val.status !== undefined) {
        entStatus = val.status;
      }
    });
    // if status exists
    if (this.status !== undefined && this.status.indexOf(',') > -1) {
      entStatus = this.status.split(',');
    }
    return entStatus;
  }

  setProgramIdBasedOnType() {
    if (this.type && this.type === 'Military') {
      this.programId = environment.miltaryProgramid;
    } else if (this.type && this.type === 'Medical') {
      this.programId = environment.medicalProgramid;
    } else if (this.type && this.type === 'Employee') {
      this.programId = environment.employeeProgramid;
    } else {
      this.programId = environment.responderProgramid;
    }
    // Form the requestparam based on the programid
    return JSON.stringify({ programId: this.programId });
  }

  addResidential() {
    if (this.address2Val.value !== '') {
      this.residentialAdd = this.address1Val.value + ',' + this.address2Val.value;
    } else {
      this.residentialAdd = this.address1Val.value;
    }
  }

  onReadyStateChange(xhrEmp: any) {
    xhrEmp.onreadystatechange = function () {
      if (xhrEmp.response && xhrEmp.readyState === 4 && xhrEmp.status === 200) {
        const collectEmployeeVerData = JSON.parse(xhrEmp.response);
        if (collectEmployeeVerData.currentStep.toLowerCase() !== 'error') {
          // set currentStepData into sessionStorage
          const setCurrentStep = {
            'currentStep': collectEmployeeVerData.currentStep,
            'submissionUrl': collectEmployeeVerData.submissionUrl,
            'verificationId': collectEmployeeVerData.verificationId
          };
          sessionStorage.setItem('ngStorage-currentStepData', JSON.stringify(setCurrentStep));
          this.tempVerificationStatus = setCurrentStep.currentStep;
          // get Org by affiliation code or job function
          if ((this.affiliationCode || this.isRapidSosOrg) && this.codeOrgDetails && this.codeOrgDetails['isSpaOrg']) {
            this.getOrgDataByAffillationCode();
          } else {
            this.getOrgByJobFunction();
          }
        } else {
          // if current step is error
          this.showLoading = false;
          this.errorMessage = collectEmployeeVerData.systemErrorMessage;
          this.errorService.displayErrorMessage(this.errorMessage);
          window.scrollTo(0, 0);
        }
      }
    }.bind(this, xhrEmp);
  }

  onReadyStateChangeIfTypeIsEmployee(xhr, data, companyInfo, newValues1, entStatus) {
    let empVerificationReqParam: any;
    let empVerificationId: any;
    xhr.onreadystatechange = function () {
      // if status is 200, then
      if (xhr.response && xhr.readyState === 4 && xhr.status === 200) {
        data = JSON.parse(xhr.response);
        empVerificationId = data.verificationId;
        const resturl2 = CFETILMEndpointsConstant.SHEER_ID_VERIFICATION_URL + '/' + empVerificationId +
          CFETILMEndpointsConstant.SHEER_ID_EMP_VER_URL;
        const xhrEmp = new XMLHttpRequest();
        empVerificationReqParam = {
          'firstName': this.firstName.value.trim(),
          'lastName': this.lastName.value.trim(),
          'email': (this.emailAddress.value && this.emailAddress.value !== '') ? this.emailAddress.value : this.userid,
          'phoneNumber': this.mobilenumberControl.value,
          'address1': this.residentialAdd,
          'state': this.stateValue.value,
          'city': this.cityVal.value,
          'postalCode': this.zipCode.value,
          'metadata': {
            'phoneNumber': this.mobilenumberControl.value,
            'agencyAddress': companyInfo.selectedAddress,
            'agencyState': companyInfo.selectedStateInWorkplace.substr(0, companyInfo.selectedStateInWorkplace.indexOf(':')),
            'agencyZipCode': companyInfo.selectedZipInWorkplace,
            'agencyCity': companyInfo.selectedCity,
            'middleName': this.middleName.value,
            'workidnumber': this.workidnumber.value,
            'workEmail': this.workEmailAddress.value,
            'employeeType': this.selectedEmpVolButton,
            'federalEmployee': this.selectedfedEmployee,
            'responderType': this.entity,
            'subAccountID': companyInfo.orgid,
            'jobFunction': this.jobfunction,
            'locationID': companyInfo.locationID ? companyInfo.locationID : '0'
          }
        };
        let orgobject = {};
        orgobject = {
          'id': 0,
          'name': companyInfo.selectedName
        };
        empVerificationReqParam.organization = orgobject;
        empVerificationReqParam = JSON.stringify(empVerificationReqParam);
        newValues1['entityStatus'] = entStatus;
        // set savedData into sessionStorage
        sessionStorage.setItem('ngStorage-savedData', JSON.stringify(newValues1));
        xhrEmp.open('POST', resturl2);
        xhrEmp.setRequestHeader('Content-Type', 'application/json');
        xhrEmp.send(empVerificationReqParam);
        this.onReadyStateChange(xhrEmp);
      }
    }.bind(this);
  }

  onReadyStateChangeIfTypeIsNotEmp(xhr, data, resturl2, companyInfo, entStatus, newValues1) {
    xhr.onreadystatechange = function () {
      if (xhr.response && xhr.readyState === 4 && xhr.status === 200) {
        data = JSON.parse(xhr.response);
        // To check if there is any errors occured
        if (data && data.errorIds && data.errorIds.length === 0) {
          let collectData: any;
          const xhr1 = new XMLHttpRequest();
          xhr1.open('GET', resturl2);
          xhr1.send();
          this.onReadyStateChangeForRestUrl2(xhr, xhr1, data, collectData, companyInfo, entStatus, newValues1);
        }
      }
    }.bind(this, xhr);
  }

  setsheerIdorgName(entity, companyInfo) {
    let sheerIdorgName: any;
    // if type is Military
    if (this.type === 'Military') {
      sheerIdorgName = entity !== 'Military First Responder' ? entity : 'Army';
    } else {
      sheerIdorgName = companyInfo.selectedName;
    }
    return sheerIdorgName;
  }

  onReadyStateChangeForRestUrl2(xhr, xhr1, data, collectData, companyInfo, entStatus, newValues1) {
    xhr1.onreadystatechange = function () {
      if (xhr1.response && xhr1.readyState === 4 && xhr1.status === 200) {
        const data1 = JSON.parse(xhr1.response);
        const verificationFunction = function () {
          this.returnVerificationFunction(data1, collectData, companyInfo, this.type, entStatus, newValues1);
        }.bind(this);
        // if type is Military
        if (this.type === 'Military') {
          const collectStatusURL = data.submissionUrl;
          const statusrequestParam = JSON.stringify({
            status: this.status
          });
          const collectStatusXhr = new XMLHttpRequest();
          newValues1['entityStatus'] = entStatus;
          // set savedData into sessionStorage
          sessionStorage.setItem('ngStorage-savedData', JSON.stringify(newValues1));
          collectStatusXhr.open('POST', collectStatusURL);
          collectStatusXhr.setRequestHeader('Content-Type', 'application/json');
          collectStatusXhr.send(statusrequestParam);
          collectStatusXhr.onreadystatechange = function () {
            if (collectStatusXhr.response && collectStatusXhr.readyState === 4 && collectStatusXhr.status === 200) {
              collectData = JSON.parse(collectStatusXhr.response);
              verificationFunction();
            }
          };
        } else {
          collectData = JSON.parse(xhr.response);
          verificationFunction();
        }
      }
    }.bind(this, xhr1);
  }

  verifyXhrStateChange(verificationxhr) {
    verificationxhr.onreadystatechange = function () {
      if (verificationxhr.response && verificationxhr.readyState === 4 && verificationxhr.status === 200) {
        const verifieddata = JSON.parse(verificationxhr.response);
        // if currentStep is not error
        if (verifieddata.currentStep.toLowerCase() !== 'error') {
          const setCurrentStep = {
            'currentStep': verifieddata.currentStep,
            'verificationId': verifieddata.verificationId,
            'submissionUrl': verifieddata.submissionUrl
          };
          sessionStorage.setItem('ngStorage-currentStepData', JSON.stringify(setCurrentStep));
          this.tempVerificationStatus = setCurrentStep.currentStep;
          // get Org by affiliation code or job function
          if ((this.affiliationCode || this.isRapidSosOrg) && this.codeOrgDetails && this.codeOrgDetails['isSpaOrg']) {
            this.getOrgDataByAffillationCode();
          } else {
            this.getOrgByJobFunction();
          }
        } else {
          // if currentStep is error
          this.errorMessage = verifieddata.systemErrorMessage;
          this.errorService.displayErrorMessage(this.errorMessage);
          this.showLoading = false;
          window.scrollTo(0, 0);
        }
      }
    }.bind(this, verificationxhr);
  }

  returnVerificationFunction(data1, collectData, companyInfo, type, entStatus, newValues1) {
    const verificationURL = collectData.submissionUrl;
    const verificationxhr = new XMLHttpRequest();
    let verrequestParam: any;

    verrequestParam = {
      'firstName': this.firstName.value.trim(),
      'lastName': this.lastName.value.trim(),
      'email': (this.emailAddress.value && this.emailAddress.value !== '') ? this.emailAddress.value : this.userid,
      'phoneNumber': this.mobilenumberControl.value,
      'birthDate': this.dateOfBirthFcontrol.value.split('/')[2] + '-' +
        this.dateOfBirthFcontrol.value.split('/')[0] + '-' + this.dateOfBirthFcontrol.value.split('/')[1],
      'metadata': {
        'phoneNumber': this.mobilenumberControl.value,
        'agencyAddress': companyInfo.selectedAddress,
        'agencyState': companyInfo.selectedStateInWorkplace.substr(0, companyInfo.selectedStateInWorkplace.indexOf(':')),
        'agencyCity': companyInfo.selectedCity,
        'agencyZipCode': companyInfo.selectedZipInWorkplace,
        'middleName': this.middleName.value,
        'workEmail': this.workEmailAddress.value,
        'workidnumber': this.workidnumber.value,
        'employeeType': this.selectedEmpVolButton,
        'responderType': this.entity,
        'federalEmployee': this.selectedfedEmployee,
        'jobFunction': this.jobfunction,
        'subAccountID': companyInfo.orgid,
        'locationID': companyInfo.locationID ? companyInfo.locationID : '0'
      }
    };
    let orgObj = {};
    // if type is military
    if (type === 'Military') {
      orgObj = {
        'id': (data1[0] && data1[0].id) ? data1[0].id : 0,
        'name': (this.entity !== 'Military First Responder') ? this.entity : 'Army'
      };
    } else {
      orgObj = {
        'id': 0,
        'name': companyInfo.selectedName
      };
    }
    verrequestParam.organization = orgObj;
    // if type is not military
    if (type !== 'Military') {
      const postalCodeFNR = companyInfo.selectedZipInWorkplace;
      verrequestParam.metadata['postalCode'] = postalCodeFNR;
      verrequestParam.statuses = entStatus;
      verrequestParam['postalCode'] = postalCodeFNR;
      newValues1['entityStatus'] = entStatus;
      sessionStorage.setItem('ngStorage-savedData', JSON.stringify(newValues1));
    }
    verrequestParam = JSON.stringify(verrequestParam);
    verificationxhr.open('POST', verificationURL);
    verificationxhr.setRequestHeader('Content-Type', 'application/json');
    verificationxhr.send(verrequestParam);
    this.verifyXhrStateChange(verificationxhr);
  }

  createOrgsData(orgInfo, userRoleType) {
    this.organizationInfo[userRoleType] = {};
    this.organizationInfo[userRoleType].orgid = orgInfo.orgid;
    this.organizationInfo[userRoleType].orgName = orgInfo.orgName;
    if ((this.affiliationCode !== '' && this.affiliationCode !== undefined) || this.isRapidSosOrg) {
      this.setOrgProfileData(orgInfo, userRoleType);
    } else {
      this.setOrgProfileData(orgInfo.profile, userRoleType);
    }
  }

  sheeridServicecall(newValues) {
    const newValues1 = newValues;
    sessionStorage.setItem('ngStorage-savedData', JSON.stringify(newValues1));
    const restURL = CFETILMEndpointsConstant.SHEER_ID_VERIFICATION_URL;
    const requestParam = this.setProgramIdBasedOnType();
    // Initiate http request
    const xhr = new XMLHttpRequest();
    // xmlHttpRequest initiate POST request
    xhr.open('POST', restURL);
    // set request header for post call
    xhr.setRequestHeader('Content-Type', 'application/json');
    // send the requestparam
    xhr.send(requestParam);
    let companyInfo: any;
    let data: any;
    const entityStatus = [{ 'status': [this.status] }];
    const programId = this.programId;
    let sheerIdOrg = '';
    companyInfo = this.geteligibilityInfo.eligibilityStatus;
    this.addResidential();
    this.showLoading = true;
    let entStatus = this.setEntityStatus(entityStatus);

    if (this.type === 'Employee' && this.status === 'EMPLOYEE') {
      this.onReadyStateChangeIfTypeIsEmployee(xhr, data, companyInfo, newValues1, entStatus);
    } else {
      // Air National Guard, Army National Guard, Military First Responder- type: Military
      sheerIdOrg = this.setsheerIdorgName(this.entity, companyInfo);
      const params = {
        programId: programId,
        sheerIdorgName: sheerIdOrg
      };
      const resturl2 = `${this.urlUtil.formatURlParams(CFETILMEndpointsConstant.SHEER_ID_ORG_VER_URL, params)}`;
      // on response of the xhr
      this.onReadyStateChangeIfTypeIsNotEmp(xhr, data, resturl2, companyInfo, entStatus, newValues1);
    }
  }

  setOrgProfileData(profile, userRoleType) {
    if (!this.organizationInfo[userRoleType].retailInfo) {
      this.organizationInfo[userRoleType].retailInfo = {};
    }
    // if affiliationCode is exists
    if ((this.affiliationCode !== '' && this.affiliationCode !== undefined) || this.isRapidSosOrg) {
      // GET_AFFILIATION_CODE returns "fan" (lowercase); GET_ORG_PROFILE returns "FAN" (uppercase) - check both.
      const fanList = profile.fan || profile.FAN;
      if (fanList && fanList.length > 0) {
        if (!this.organizationInfo[userRoleType].retailFanAccountList) {
          this.organizationInfo[userRoleType].retailFanAccountList = {};
        }
        fanList.forEach(val2 => {
          if (val2?.retCode && val2.retCode.toLowerCase() === this.affiliationCode.toLowerCase()) {
            this.organizationInfo[userRoleType].retailFanAccountList['fanName'] = val2.fan;
            this.organizationInfo[userRoleType].fanName = val2.fan;
          }
        });
      }
      // call addUser
      this.addUser();
    } else {
      this.setUserRoleTypeInOrgInfoIfAffiliationCodeExist(profile, userRoleType);
      this.addUser();
    }
  }

  setUserRoleTypeInOrgInfoIfAffiliationCodeExist(profile, userRoleType) {
    profile.forEach(val => {
      if (val.attribute_value !== undefined) {
        this.organizationInfo[userRoleType].retailInfo[val.attribute_name] = val.attribute_value;
      } else {
        this.organizationInfo[userRoleType].retailInfo[val.attribute_name] = val.attribute_mvalue;
      }
      if (val.attribute_name === 'FAN_LIST') {
        if (!this.organizationInfo[userRoleType].retailFanAccountList) {
          this.organizationInfo[userRoleType].retailFanAccountList = {};
        }
        val.attribute_mvalue.forEach(val2 => {
          this.organizationInfo[userRoleType].fanName = val2;
          this.organizationInfo[userRoleType].retailFanAccountList['fanName'] = val2;
        });
      }
    });
  }

  addUser() {
    if (this.emailAddress && this.emailAddress.value !== '' && this.lastName && this.lastName.value !== '') {
      const request = {
        'company_id': environment.companyId,
        'userid': this.emailAddress.value.trim(),
        'verification_attributes':
          [
            {
              'attribute_name': 'sn',
              'attribute_value': this.lastName.value.trim()
            }
          ],
        'notification_method': 'list',
        'notification_value': '',
        'notification_flow': 'actv'
      };
      console.log("customer-information-form - addUser: calling Verify Identity");
      this.cfetService.cfetLivePost(request, CFETILMEndpointsConstant.VERIFY_IDENTITY_ACTIVATION).subscribe((data) => {
        console.log("customer-information-form - addUser - calling verifyIdentityActivationSuccessInAddUser");
        this.verifyIdentityActivationSuccessInAddUser(data);
      }, (error) => {
        console.log("customer-information-form - addUser - calling verifyIdentityActivationFailedInAddUser");
        this.verifyIdentityActivationFailedInAddUser(error);
      });
    }
  }

  verifyIdentityActivationSuccessInAddUser(data) {
    if (data && data.error && data.error.errorcode && data.error.errorcode === 1033) {
      this.cfetLivePostDataError1033(data);
    } else if (data && data.error && data.error.errorcode ||
      (data && data.status === 'Success' && data.available_notification_methods !== undefined) || (data && data.errorcode === 1047)) {
      this.cfetLivePostDataError1047();
    }
  }

  verifyIdentityActivationFailedInAddUser(error) {
    if (error.error.errorcode && error.error.errorcode === 1033) {
      this.cfetLivePostDataError1033(error);
    } else if (error && error.error.errorcode && (error.error.errorcode === 1019 || error.error.errorcode === 1016 || error.error.errorcode === 1047)) {
      this.cfetLivePostDataError1047();
    }
  }

  cfetLivePostDataError1033(dataError: any) {
    let uaactvidx;
    dataError.error.variables.forEach((element, uaactvindx) => {
      if (element === 'ua_actv') {
        uaactvidx = uaactvindx;
      }
    });
    const ua_actv = dataError.error.variables[uaactvidx + 1];
    this.addUserBasedonOrg(ua_actv, this.orgIdSelected);
  }

  cfetLivePostDataError1047() {
    this.showLoading = false;
    this.emailAlreadyExistsFlag = true;
    this.inputEmail.nativeElement.focus();
    const messageArray = [];
    messageArray.push(this.cfetMessages.CFET_ERROR_1007, this.cfetMessages.CFET_eligibility_existing_user);
    this.errorService.displayErrorMessageList(messageArray);
  }

  setSheeridCurrentStep() {
    if (sessionStorage.getItem('ngStorage-currentStepData') &&
      Object.keys(sessionStorage.getItem('ngStorage-currentStepData').length > 0)) {
      this.sheeridCurrentStep = JSON.parse(sessionStorage.getItem('ngStorage-currentStepData'));
    }
  }

  returnTrueIfSelectedfedEmployeeIsYes() {
    return (this.selectedfedEmployee === 'Yes') ? true : false;
  }

  addUserBasedonOrg(addToken, userRoleType) {
    this.retailFanAccountList = [];
    this.organizationid = this.organizationInfo[userRoleType].orgid;
    this.organisationName = this.organizationInfo[userRoleType].orgName;
    this.fanName = this.organizationInfo[userRoleType].fanName;
    this.retailFanAccountList['fanName'] = this.organizationInfo[userRoleType].retailFanAccountList['fanName'];
    this.selectedValue.fan = this.organizationInfo[userRoleType].fanName;
    // concat email to addToken
    this.userid = addToken.concat(this.emailAddress.value);
    let requestParam: any;
    let isFederal = this.returnTrueIfSelectedfedEmployeeIsYes();
    requestParam = {
      'userid': this.userid,
      'self_add': true,
      'company_id': environment.companyId,
      'profile': [
        {
          'attribute_name': 'cn',
          'attribute_value': this.firstName.value.trim()
        },
        {
          'attribute_name': 'sn',
          'attribute_value': this.lastName.value.trim()
        },
        {
          'attribute_name': 'OrgID',
          'attribute_mvalue': [
            this.organizationid
          ]
        },
        {
          'attribute_name': 'Org_Name',
          'attribute_mvalue': [
            this.organisationName
          ]
        },
        {
          'attribute_name': 'FAN',
          'attribute_mvalue': [
            this.selectedValue.fan
          ]
        },
        {
          'attribute_name': 'contactEmail',
          'attribute_value': this.emailAddress.value
        }, {
          'attribute_name': 'contactCTNisFN',
          'attribute_value': 'FALSE'
        }, {
          'attribute_name': 'contactCTN',
          'attribute_value': this.mobilenumberControl.value.replace(/-/g, '')
        }, {
          'attribute_name': 'zipcode',
          'attribute_value': this.zipCode.value
        }, {
          'attribute_name': 'state',
          'attribute_value': this.stateValue.value
        }, {
          'attribute_name': 'city',
          'attribute_value': this.cityVal.value
        }, {
          'attribute_name': 'Address 1',
          'attribute_value': this.address1Val.value
        }, {
          'attribute_name': 'Address 2',
          'attribute_value': this.address2Val.value
        }, {
          'attribute_name': 'employeeType',
          'attribute_value': this.selectedEmpVolButton
        }, {
          'attribute_name': 'firstResponderType',
          'attribute_value': this.entity
        }, {
          'attribute_name': 'dateOfBirthFcontrol',
          'attribute_value': this.dateOfBirthFcontrol.value.split('/')[2] + '-' +
            this.dateOfBirthFcontrol.value.split('/')[0] + '-' + this.dateOfBirthFcontrol.value.split('/')[1]
        }, {
          'attribute_name': 'agencyEmail',
          'attribute_value': this.workEmailAddress.value
        }, {
          'attribute_name': 'firstResponderTypeClass',
          'attribute_value': this.jobfunction
        }, {
          'attribute_name': 'employeeId',
          'attribute_value': this.workidnumber.value
        }, {
          'attribute_name': 'premierRoleType',
          'attribute_value': 'VOLUNTEER'
        }, {
          'attribute_name': 'federal',
          'attribute_value': isFederal
        }, {
          'attribute_name': 'subType',
          'attribute_value': this.subType
        }, {
          'attribute_name': 'user_type',
          'attribute_value': this.userType
        }, {
          'attribute_name': 'firstResponderConfirmation',
          'attribute_value': '1'
        }
      ],
      'entitlement': [
        {
          'attribute_name': 'G_FN'
        },
        {
          'attribute_name': 'G_FN_VOL'
        }
      ]
    };
    this.setSheeridCurrentStep();
    requestParam = this.setRequestParam(requestParam);
    this.cfetService.cfetLivePost(requestParam, CFETILMEndpointsConstant.ADD_USER_V3).subscribe((data) => {
      this.addUserV3Success(data);
    },
      (error) => {
        this.createUserSuccess = true;
        this.showLoading = false;
        this.errorMessage = error.error.message;
        this.errorService.displayErrorMessage(this.errorMessage);
      });
  }

  setRequestParam(requestParam) {
    if (this.sheeridCurrentStep && this.sheeridCurrentStep['verificationId']) {
      requestParam.profile.push({
        'attribute_name': 'verificationStatus',
        'attribute_value': this.sheeridCurrentStep['currentStep']
      });
      requestParam.profile.push({
        'attribute_name': 'verificationId',
        'attribute_value': this.sheeridCurrentStep['verificationId']
      });
    }
    if (this.middleName.value !== '') {
      requestParam.profile.push({
        'attribute_name': 'mn',
        'attribute_value': this.middleName.value.trim()
      });
    }
    if (this.affiliationCode !== '') {
      requestParam.profile.push({
        'attribute_name': 'retCodeAssigned',
        'attribute_value': this.affiliationCode
      });
    }
    requestParam = this.setAgencyNameAndDetailsInRequestParam(requestParam);
    return requestParam;
  }

  setAgencyNameAndDetailsInRequestParam(requestParam) {
    // agency name and address details
    if (((this.affiliationCode && this.isSpaOrg) || (!this.affiliationCode)) &&
      (this.selectedagencyInfo.selectedCity && this.selectedagencyInfo.selectedCity !== '')) {
      requestParam.profile.push(
        {
          'attribute_name': 'agencyCity',
          'attribute_value': this.selectedagencyInfo.selectedCity
        });
    }
    if (((this.affiliationCode && this.isSpaOrg) || (!this.affiliationCode)) && this.selectedagencyInfo.selectedName) {
      requestParam.profile.push(
        {
          'attribute_name': 'agencyName',
          'attribute_value': this.selectedagencyInfo.selectedName
        });
    }
    this.setSelectedStateAndZipcodeInWorkplace(requestParam);
    if (((this.affiliationCode && this.isSpaOrg) || (!this.affiliationCode)) && this.selectedagencyInfo.selectedAddress) {
      requestParam.profile.push(
        {
          'attribute_name': 'agencyAddress',
          'attribute_value': this.selectedagencyInfo.selectedAddress
        });
    }
    return requestParam;
  }

  setSelectedStateAndZipcodeInWorkplace(requestParam) {
    if (((this.affiliationCode && this.isSpaOrg) || (!this.affiliationCode)) &&
      (this.selectedagencyInfo.selectedStateInWorkplace && this.selectedagencyInfo.selectedStateInWorkplace !== '')) {
      requestParam.profile.push(
        {
          'attribute_name': 'agencyState',
          'attribute_value': this.selectedagencyInfo.selectedStateInWorkplace
        });
      requestParam.profile.push(
        {
          'attribute_name': 'agencyZipcode',
          'attribute_value': this.selectedagencyInfo.selectedZipInWorkplace
        });
    }
    return requestParam;
  }

  addUserV3Success(data) {
    if (data && data.status === 'success') {
      this.createUserSuccess = true;
      this.displayVerificationMessage();
    } else if (data && data.errorcode) {
      this.showLoading = false;
      if (data.errorcode === 1007 || data.errorcode === 2008) {
        this.errorMessage = data.message;
        this.errorService.displayErrorMessage(this.errorMessage);
        window.scrollTo(0, 0);
      }
    } else {
      if (data.message) {
        this.errorMessage = data.message;
        this.showLoading = false;
        this.errorService.displayErrorMessage(this.errorMessage);
      }
      // Scroll bar to the top
      window.scrollTo(0, 0);
    }
  }

  displayVerificationMessage() {
    this.showVerificationNotRequired = false;
    this.showPersonalInfoSection = false;
    this.showInstantVerificationSection = false;
    this.showVerificationPending = false;
    if (this.tempVerificationStatus.toLowerCase() === 'notrequired') {
      this.showVerificationNotRequired = true;
      const orgobject = { 'orgname': this.organisationName };
      sessionStorage.setItem('orgName', JSON.stringify(orgobject));
    } else if (this.tempVerificationStatus.toLowerCase() === 'success') {
      this.showInstantVerificationSection = true;
    } else {
      this.showVerificationPending = true;
    }
    this.showLoading = false;
    this.hideEditButton.emit(true);
    if (this.showInstantVerificationSection || this.showVerificationNotRequired) {
      this.goToInstantVerification.emit(true);
    }
  }

  getOrgByJobFunction() {
    const rapidSosReqParam = {
      'search_criteria': [{
        'attribute_name': 'isSpaOrg',
        'attribute_value': 'true'
      }, {
        'attribute_name': 'isRapidSOS',
        'attribute_value': 'true'
      }],
      'filter_attribute': 'responder_sub_category'
    };
    // RapidSOS orgs aren't flagged in the isSpaOrg response, so fetch them separately and exclude by orgid.
    this.cfetService.cfetLivePost(rapidSosReqParam, CFETILMEndpointsConstant.SEARCH_DETAILS).subscribe(
      (rapidSosData: any) => this.fetchSpaOrgsExcludingRapidSos(this.collectOrgIds(rapidSosData)),
      (_error) => this.handleOrgSearchError());
  }

  fetchSpaOrgsExcludingRapidSos(rapidSosOrgIds: Set<string>) {
    const reqParam = {
      'search_criteria': [{
        'attribute_name': 'isSpaOrg',
        'attribute_value': 'true'
      }],
      'filter_attribute': 'responder_sub_category'
    };
    this.cfetService.cfetLivePost(reqParam, CFETILMEndpointsConstant.SEARCH_DETAILS).subscribe((data: any) => {
      // Move the scroll bar to top
      window.scrollTo(0, 0);
      if (data) {
        const filteredData = data.filter(org => !rapidSosOrgIds.has(org.orgid));
        let keepgoing = true;
        this.setProfileDataForEveryOrg(filteredData, keepgoing);
        if (this.orgIdSelected) {
          this.getRetManagerRole();
        }
      }
    },
      (_error) => this.handleOrgSearchError());
  }

  collectOrgIds(data: any): Set<string> {
    const orgIds = new Set<string>();
    if (Array.isArray(data)) {
      data.forEach(org => {
        if (org?.orgid) {
          orgIds.add(org.orgid);
        }
      });
    }
    return orgIds;
  }

  handleOrgSearchError() {
    this.showLoading = false;
    this.errorMessage = this.cfetMessages.official_doc_system_error;
    this.errorService.displayErrorMessage(this.errorMessage);
    window.scrollTo(0, 0);
  }

  setProfileDataForEveryOrg(data, keepgoing) {
    data.forEach(val1 => {
      if (val1.profile && keepgoing) {
        this.respondertypes = [];
        this.profileData = val1.profile;
        this.setOrgIdSelectedUsingResponderTypes(keepgoing, val1);
      }
    });
  }

  setOrgIdSelectedUsingResponderTypes(keepgoing, val1) {
    this.profileData.forEach(val2 => {
      if (keepgoing) {
        if (val2.attribute_name === 'responder_sub_category') {
          this.respondertypes = val2.attribute_mvalue;
        }
        if (this.respondertypes) {
          this.responderTypes = [];
          this.respondertypes.forEach(val => {
            this.responderTypes.push(val.trim().toLowerCase());
          });
          if (this.responderTypes.indexOf(this.jobfunction.toLowerCase()) !== -1) {
            keepgoing = false;
            this.orgIdSelected = val1.orgid;
          }
        }
      }
    });
  }

  cancelCreation(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.showCancelModal.emit(true);
    }
  }

  getRetManagerRole() {
    // Assigning the retail agent role from headers
    this.retailAgentGroup = 'G_FN_AGT_RS';
    const agentGroup = {
      retailAgentGroup: this.retailAgentGroup
    };
    const restURL = `${this.urlUtil.formatURlParams(CFETILMEndpointsConstant.FETCH_ORG_BY_GROUP, agentGroup)}`;
    this.cfetService.cfetLiveGet('', restURL).subscribe((data: any) => {
      // Move the scroll bar to top
      window.scrollTo(0, 0);
      // Data from the service call
      if (data) {
        this.organizationInfo = {};
        data.forEach(orgInfo => {
          if (orgInfo.orgid === this.orgIdSelected) {
            this.createOrgsData(orgInfo, this.orgIdSelected);
          }
        });
      } else {
        this.showLoading = false;
      }
    });
    window.scrollTo(0, 0);
  }

  goToDocUpload(event) {
    if (event) {
      this.showVerificationPending = false;
      this.showDocUploadSection = true;
    }
  }

  goToDocReceived(event) {
    if (event) {
      this.showDocUploadSection = false;
      this.showDocReviewPending = true;
    }
  }

  redirectToLogin(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      const url = environment.loginURL;
      this.redirectUrl(url);
    }
  }

  redirectUrl(url) {
    window.location.href = url;
  }

  setNewSession(event) {
    if (event) {
      this.setSessionTimeout.emit(true);
    }
  }

  displayCancelModal(event) {
    if (event) {
      this.showCancelModal.emit(true);
    }
  }
}
